"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReclassify = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../__generated__/graphql");
const apollo_client_utils_1 = require("../../../apollo-client/apollo-client.utils");
const hooks_1 = require("../../client/hooks");
const product_1 = require("../../client/product");
const product_tree_nodes_1 = require("../../client/product-tree-nodes");
const utils_1 = require("../../utils");
const hooks_2 = require("../../../hooks");
const localization_1 = require("../../../localization");
const store_1 = require("../../../store");
const useReclassify = ({ selectedTreeNodePath, selectedItemsCount = 0, expectedMatchedProductCount, }) => {
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const selectedProductTreeNodeId = (0, utils_1.getTreeNodeIdFromPath)(selectedTreeNodePath);
    const { getTreeNodePaths } = (0, product_tree_nodes_1.useTreeNodePaths)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const { addSuccess, addError } = (0, hooks_2.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { refetchProductList, refetchProductTreeNodes } = (0, hooks_1.useRefetchQueries)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { addBulkAssertions, error, loading: areBulkAssertionsLoading, } = (0, product_1.usePromisedBulkAssertions)({ catalogId });
    const reclassify = (0, react_1.useCallback)((_a) => __awaiter(void 0, [_a], void 0, function* ({ filter, targetCategory }) {
        var _b;
        setIsLoading(true);
        const assertion = [{
                categories: [{ category: targetCategory, type: graphql_1.ProductAttributeAssertionType.Exclusive }],
                filter: filter.product,
                nodeStrategyAttributes: filter.nodeStrategyAttributes,
                presentationAttributes: filter.presentationAttributes,
                presentationAttributeFilterStrategy: filter.presentationAttributeFilterStrategy,
                productTreeNodeId: selectedProductTreeNodeId,
            }];
        try {
            const { selectedNodeTitle = targetCategory, productsCount = 0 } = yield addBulkAssertions(assertion, expectedMatchedProductCount);
            const { data: updatedPaths } = yield getTreeNodePaths({
                variables: {
                    productTreeId,
                    sort: [{ distance: graphql_1.SortOrder.Asc }],
                    filter: {
                        title: {
                            equals: selectedNodeTitle,
                        },
                    },
                },
            });
            const params = {
                totalCount: productsCount || selectedItemsCount,
                targetNodePath: (_b = updatedPaths === null || updatedPaths === void 0 ? void 0 : updatedPaths[0]) !== null && _b !== void 0 ? _b : '',
                targetNodeTitle: selectedNodeTitle,
            };
            const treeNodeIdsToUpdate = [
                ...selectedTreeNodePath.split(store_1.STRATEGY_NODE_PATH_SEPARATOR),
                ...(params.targetNodePath ? params.targetNodePath.split(store_1.STRATEGY_NODE_PATH_SEPARATOR) : []),
            ];
            if (treeNodeIdsToUpdate.length) {
                try {
                    yield refetchProductTreeNodes(treeNodeIdsToUpdate);
                }
                catch (error) {
                    // TODO: figure out why we're getting AbortError here
                    if (!(0, apollo_client_utils_1.isAbortError)(error)) {
                        throw error;
                    }
                }
            }
            const successNotificationMessage = (t({
                key: 'PRODUCT_RECLASSIFY_SUCCESS_MESSAGE',
                values: {
                    totalCount: params.totalCount,
                    title: params.targetNodeTitle,
                },
            })).trim();
            // Refetch to sync with backend data
            void refetchProductList(selectedProductTreeNodeId).catch((error) => {
                // TODO: figure out why we're getting AbortError here
                if (!(0, apollo_client_utils_1.isAbortError)(error)) {
                    addError(error instanceof Error ? error.message : String(error));
                }
            });
            addSuccess(params.totalCount
                ? successNotificationMessage
                : successNotificationMessage.charAt(0).toUpperCase() + successNotificationMessage.slice(1));
            return params;
        }
        catch (e) {
            const errorMessage = e instanceof Error ? e.message : String(e);
            addError(errorMessage);
            throw e;
        }
        finally {
            setIsLoading(false);
        }
    }), [
        addBulkAssertions,
        addError,
        addSuccess,
        getTreeNodePaths,
        productTreeId,
        refetchProductList,
        refetchProductTreeNodes,
        selectedProductTreeNodeId,
        selectedTreeNodePath,
        selectedItemsCount,
        expectedMatchedProductCount,
        t,
    ]);
    return {
        error: error === null || error === void 0 ? void 0 : error.message,
        isLoading: isLoading || areBulkAssertionsLoading,
        reclassify,
    };
};
exports.useReclassify = useReclassify;
